module.exports = __webpack_public_path__ + "img/ExpirySyncDateEditBtn.39f332e9.png";